import { useMemo } from 'react';
import { computeFormValidation } from './formValidation';
import { CheckCircle, WarningCircle } from '@phosphor-icons/react';

export function FormProgressBar({ formData }) {
  const { progress, missing } = useMemo(() => computeFormValidation(formData), [formData]);

  const barColor =
    progress === 100 ? 'bg-emerald-500' :
    progress >= 70 ? 'bg-blue-500' :
    progress >= 40 ? 'bg-amber-500' :
    'bg-red-500';

  const textColor =
    progress === 100 ? 'text-emerald-600' :
    progress >= 70 ? 'text-blue-600' :
    progress >= 40 ? 'text-amber-600' :
    'text-red-600';

  return (
    <div className="bg-white border border-slate-200 rounded-sm p-4 sticky top-16 z-[5]" data-testid="form-progress-bar">
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center gap-2">
          {progress === 100 ? (
            <CheckCircle size={20} weight="fill" className="text-emerald-500" />
          ) : (
            <WarningCircle size={20} weight="fill" className={textColor} />
          )}
          <span className={`text-sm font-bold ${textColor}`} data-testid="progress-percentage">
            {progress}% Complete
          </span>
        </div>
        <span className="text-xs text-slate-400">
          {missing.length === 0 ? 'Ready to submit' : `${missing.length} field${missing.length === 1 ? '' : 's'} remaining`}
        </span>
      </div>
      <div className="w-full bg-slate-100 rounded-full h-2.5 overflow-hidden">
        <div
          className={`${barColor} h-full rounded-full transition-all duration-500 ease-out`}
          style={{ width: `${progress}%` }}
          data-testid="progress-fill"
        />
      </div>
    </div>
  );
}
